import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ececec',
    '& #kebab': {
      color: '#263057'
    }
  },
  row: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ececec',
      '& #kebab': {
        color: '#263057'
      }
    }
  },
  itemCheck: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#6e7a76',
    width: '5%',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    textAlign: 'center'
  },
  itemName: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '25%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemNameLegal: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '25%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 700px)': {
      display: 'none'
    }
  },
  itemCUIT: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '15%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemType: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 950px)': {
      display: 'none'
    }
  },
  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '5%',
    textAlign: 'start',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyles
